<template>
  <v-container 
    tag="section"
    fluid>
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row align="center">
        <v-col cols="12">
          <parametros-variacao-preco-unitario 
            :variacao="variacao"
            ref="variacoesPrecoUnitarioParams" 
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-variacao-preco-unitario"
            color="success"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarVariacao()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import VariacoesPrecoUnitarioService from '@/services/VariacoesPrecoUnitarioService.js';
import tourMixins from '@/mixins/tourMixins';

export default {
  name: "VariacoesPrecoUnitarioEdit",

  mixins: [tourMixins],

  components: { 
    ParametrosVariacaoPrecoUnitario: () => import("@/components/variacoesPrecoUnitario/ParametrosVariacaoPrecoUnitario.vue"),
  },

  mounted() {
    if (this.$route.params.id) {
      this.getVariacao(this.$route.params.id);
    }

    this.iniciarTourPagina();
  },

  data() {
    return {
      variacao: {},
      loading: false,
      arrTour: [
        {
          element: '#titulo-variacao-preco-unitario',
          intro: 'Aqui você deve inserir um nome para sua Variação de Preço Unitário.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#tucs-variacao-preco-unitario',
          intro: 'Aqui você deve selecionar quais TUCs devem ser incluídas no sua Variação de Preço Unitário.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#variaveis-variacao-preco-unitario',
          intro: 'Aqui você deve selecionar quais variáveis devem ser incluídas no sua Variação de Preço Unitário.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#btn-save-variacao-preco-unitario',
          intro: 'Após seleção dos critérios anteriores clique aqui para salvar e executar sua Variação de Preço Unitário.',
          scrollTo: "tooltip",
          position: 'left'
        }
      ]
    }
  },

  methods: {
    getVariacao(id) {
      VariacoesPrecoUnitarioService.getItem(id)
        .then(res => {
          this.variacao = res.data.item;
        }).catch(err => {
          console.error(err);
          this.$toast.error('Erro ao recuperar Variação de Preço Unitário.', '', { position:'topRight' });
          this.$router.push({ name: 'Variações de Preço Unitário Histórico' });
        });
    },
    
    salvarVariacao() {
      const id = !this.$route.params.id ? null : this.$route.params.id;
      const postData = this.$refs.variacoesPrecoUnitarioParams.exportData();
      
      this.loading = true;
      
      VariacoesPrecoUnitarioService.salvarItem(postData, id)
        .then(() => {
          this.$toast.success('Variação de Preço Unitário salva com sucesso.', '', { position:'topRight' })
          this.$router.push({ name: 'Variações de Preço Unitário Histórico' });
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao salvar Variação de Preço Unitário.', '', { position:'topRight' });
        })
        .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
};
</script>